export const hfaData = {
    "UAB": 4,
"Georgia Southern": 3.8,
"SMU": 3.7,
"Washington State": 3.7,
"LSU": 3.6,
"Temple": 3.5,
"Kansas State": 3.5,
"Tulane": 3.5,
"Alabama": 3.4,
"Oklahoma": 3.4,
"Ohio": 3.4,
"Notre Dame": 3.3,
"Utah": 3.3,
"Louisville": 3.3,
"Texas Tech": 3.3,
"Penn State": 3.3,
"Wyoming": 3.3,
"Texas": 3.2,
"Duke": 3.2,
"Utah State": 3.1,
"Buffalo": 3.1,
"Rice": 3.1,
"James Madison": 3.1,
"Oregon State": 3,
"New Mexico State": 3,
"Liberty": 3,
"Iowa State": 3,
"Ohio State": 2.9,
"Virginia": 2.9,
"Boise State": 2.9,
"West Virginia": 2.9,
"Missouri": 2.9,
"Syracuse": 2.9,
"Colorado": 2.9,
"Minnesota": 2.8,
"USC": 2.8,
"Arizona State": 2.8,
"California": 2.8,
"Washington": 2.8,
"Miami Ohio": 2.7,
"Florida": 2.7,
"Toledo": 2.7,
"Western Kentucky": 2.7,
"Fresno State": 2.7,
"Iowa": 2.7,
"Air Force": 2.7,
"Louisiana Tech": 2.7,
"Indiana": 2.6,
"South Carolina": 2.6,
"Auburn": 2.6,
"Navy": 2.6,
"NC State": 2.6,
"Virginia Tech": 2.6,
"Baylor": 2.6,
"UConn": 2.5,
"Hawai'i": 2.5,
"UTSA": 2.5,
"Mississippi State": 2.5,
"South Alabama": 2.5,
"San Jose State": 2.5,
"Tennessee": 2.5,
"Oregon": 2.5,
"Michigan": 2.5,
"Oklahoma State": 2.5,
"Middle Tennessee": 2.4,
"Kentucky": 2.4,
"Western Michigan": 2.4,
"Memphis": 2.4,
"Clemson": 2.4,
"Arkansas State": 2.4,
"Kansas": 2.4,
"UCF": 2.4,
"North Texas": 2.4,
"Southern Miss": 2.4,
"BYU": 2.3,
"Colorado State": 2.3,
"Ole Miss": 2.3,
"Louisiana": 2.3,
"Arizona": 2.3,
"Pittsburgh": 2.3,
"Florida International": 2.3,
"Ball State": 2.3,
"UNLV": 2.3,
"Boston College": 2.2,
"Texas A&M": 2.2,
"Wake Forest": 2.2,
"Nevada": 2.2,
"South Florida": 2.2,
"Rutgers": 2.1,
"Coastal Carolina": 2.1,
"Central Michigan": 2.1,
"Army": 2.1,
"Maryland": 2.1,
"East Carolina": 2.1,
"Northwestern": 2.1,
"Texas State": 2,
"Florida State": 2,
"Marshall": 2,
"TCU": 1.9,
"ULM": 1.9,
"Appalachian State": 1.9,
"Eastern Michigan": 1.9,
"UTEP": 1.9,
"Georgia Tech": 1.8,
"Houston": 1.8,
"Miami": 1.8,
"North Carolina": 1.8,
"Troy": 1.8,
"Wisconsin": 1.7,
"Arkansas": 1.7,
"Illinois": 1.7,
"Nebraska": 1.6,
"Cincinnati": 1.6,
"San Diego State": 1.6,
"UCLA": 1.6,
"New Mexico": 1.6,
"Florida Atlantic": 1.5,
"Old Dominion": 1.5,
"Kent State": 1.5,
"UMass": 1.4,
"Georgia State": 1.4,
"Georgia": 1.4,
"Charlotte": 1.4,
"Bowling Green": 1.3,
"Stanford": 1.3,
"Vanderbilt": 1.3,
"Akron": 1.1,
"Michigan State": 1.1,
"Purdue": 0.8,
"Northern Illinois": 0.8,
"Tulsa": 0.7,

}
